import { makeAutoObservable } from "mobx";

export class ActivityQueueStore {
  panelOpen: boolean = false;
  anchorEl: HTMLElement | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  openPanel(anchorEl: HTMLElement) {
    this.anchorEl = anchorEl;
    this.panelOpen = true;
  }

  closePanel() {
    this.panelOpen = false;
    this.anchorEl = null;
  }

  togglePanel(anchorEl?: HTMLElement) {
    if (this.panelOpen) {
      this.closePanel();
    } else if (anchorEl) {
      this.openPanel(anchorEl);
    }
  }
}
